module.exports = __webpack_public_path__ + "img/ywt_list_img1.cd7a39f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/saasIntroduction/ywt_list_img1.png
// module id = LuUU
// module chunks = 136